import { getAuthAxiosBackend } from "@/helpers/axios"

class SkillsServices {
    get(id) {
        return getAuthAxiosBackend().get('Skills/getSkillsById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('Skills/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('Skills/addSkills', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('Skills/updateSkills/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('Skills/restoreSkills' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('Skills/softDeleteSkills/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('Skills/deleteSkills/' + id.toString())
    }
}

export default new SkillsServices()
